<script setup></script>
<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">BULK UPLOAD SUMMARY</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item">
              <a href="#">Dashboard</a>
            </li>
            <li class="breadcrumb-item active">Bulk Devices Upload</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
